import type { PostingTemplateMapping } from '@/types/postingTemplate';

// Commonality mappings are intentionally valid without a concrete attribute value;
// every other mapping type needs a non-empty value to count as mapped.
export const isMappingValid = (mapping: PostingTemplateMapping | null | undefined): boolean => {
  if (!mapping) return false;

  if (mapping.value_type === 'commonality') {
    return true;
  }

  return mapping.attribute_value !== null && mapping.attribute_value !== undefined && mapping.attribute_value !== '';
};

export const isAttributeUnmapped = (mappings: PostingTemplateMapping[] | null | undefined): boolean => {
  if (!mappings || mappings.length === 0) return true;

  return mappings.every((mapping) => !isMappingValid(mapping));
};
